<template>
  <div>
    <div>
      <Header> </Header>
    </div>
    <div class="main">
      <Introduction></Introduction>
      <Video></Video>
      <Features></Features>
      <Analytics></Analytics>
      <Review></Review>
      <GetStarted></GetStarted>
      <Feedback></Feedback>
      <Footer> </Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/layout/header";
import Footer from "@/layout/footer";
import Introduction from "@/components/introSection";
import Video from "@/components/videoSection";
import Features from "@/components/featuresSection";
import Feedback from "@/components/feedbackSection";
import GetStarted from "@/components/getStartedSection";
import Review from "@/components/reviewSection";
import Analytics from "@/components/analyticsSection";
import { mapGetters } from "vuex";
import { setLocale } from "../services/firebase";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    Introduction,
    Video,
    Features,
    Feedback,
    GetStarted,
    Review,
    Analytics,
  },
  mounted() {
    setLocale();
  },
  computed: {
    ...mapGetters({
      user: "user",
      state: "state",
    }),
  },
  watch: {
    // call again the method if the route changes
    $route: "init",
  },
};
</script>
